var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ratio ratio-16x9",domProps:{"innerHTML":_vm._s(_vm.content.map)}})
}
var staticRenderFns = []

export { render, staticRenderFns }